export default __webpack_public_path__ + "static/icon-tile-bold-dont-a70831157d7d6c0a947dc1c6d09450cb339305f9198769091f74278d302aadbc.png";